import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";
import { initGA, injectScript, isPrerender } from "./utils/ga";

const gtagId = process.env.REACT_APP_GTAG_ID;
const ATS_SCRIPT_ID = "anymind-ats-sdk";
const ATS_SCRIPT_SRC = "https://anymind360.com/js/20399/ats.js";

if (!isPrerender() && process.env.NODE_ENV === "production") {
  if (gtagId) {
    initGA(gtagId);
  }
  injectScript(ATS_SCRIPT_SRC, ATS_SCRIPT_ID);
}

const container = document.getElementById("root") as HTMLElement;
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// react-snap prerenders into #root; hydrate to preserve that HTML for crawlers.
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
